import { Chip, FontAwesomeIcon } from '@appcharge/shared-ui';

import type { InputSelectDropdownOption } from '../../InputSelectDropdown/InputSelectDropdown';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  UIButton
} from '../../ui';

type EnhanceOptionsWithActionsParams = {
  options: InputSelectDropdownOption[];
  onEdit?: (option: InputSelectDropdownOption) => void;
  onDelete?: (option: InputSelectDropdownOption) => void;
  onStartEdit: (option: InputSelectDropdownOption, e: React.MouseEvent) => void;
  onDeleteClick: (option: InputSelectDropdownOption, e: React.MouseEvent) => void;
};

export const enhanceOptionsWithActions = ({
  options,
  onEdit,
  onDelete,
  onStartEdit,
  onDeleteClick
}: EnhanceOptionsWithActionsParams): InputSelectDropdownOption[] => {
  if (!onEdit && !onDelete) {
    return options;
  }

  return options.map((option) => {
    const actionsMenu = (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <UIButton
            variant="ghost"
            size="sm"
            className="h-6 w-6 p-0 hover:bg-base-accent"
            onClick={(e) => e.stopPropagation()}
            data-testid={
              option.dataTestId
                ? `${option.dataTestId}-menu-trigger`
                : `UploadContent-TypeSelect-${option.value}-menu-trigger`
            }
          >
            <FontAwesomeIcon
              icon="fa-regular fa-ellipsis-vertical"
              className="text-base-foreground text-xs"
            />
          </UIButton>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="end"
          className="bg-base-popover border-base-border rounded-md min-w-[100px]"
          onClick={(e) => e.stopPropagation()}
        >
          {onEdit && (
            <DropdownMenuItem
              onClick={(e) => onStartEdit(option, e)}
              className="text-base-popoverForeground text-p-s hover:bg-base-accent cursor-pointer"
            >
              Edit
            </DropdownMenuItem>
          )}
          {onDelete && (
            <DropdownMenuItem
              onClick={(e) => onDeleteClick(option, e)}
              className="text-base-destructive text-p-s hover:bg-base-accent cursor-pointer"
            >
              Delete
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    );

    const chipLabel = (
      <Chip status="primary" className="bg-[rgba(64,64,64,0.20)] text-neutral-700">
        {option.label}
      </Chip>
    );

    if (option.rightIcon) {
      return {
        ...option,
        leftIcon: chipLabel,
        hideLabel: true,
        rightIcon: (
          <div className="flex items-center gap-2">
            {option.rightIcon}
            {actionsMenu}
          </div>
        )
      };
    }

    return {
      ...option,
      leftIcon: chipLabel,
      hideLabel: true,
      rightIcon: actionsMenu
    };
  });
};
